import { useEffect, useState } from 'react';

import { consumersActions } from '@store/consumers/consumers.slice';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { Tabs } from '@atom/tabs/tabs';
import { ApplicationLogs } from '@component/tables/application-logs/application-logs';
import { EventLogs } from '@component/tables/event-logs/event-logs';
import { RequestLogs } from '@component/tables/request-logs/request-logs';
import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { useSearchLocation } from '@hook/common/use-search-location.hook';
import { useLazyGetAccessTokenQuery } from '@hook/consumer/consumer.hooks';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isExist, isString } from '@util/data/is-exist';

import { LogTabEnum } from './logs.enum';
import { ConsumerSelect, HeaderWrapper } from './logs.page-style';

export const LogsPage = () => {
  const [{ currentTab: searchTab, consumer: searchConsumer }, setSearchParams] = useSearchLocation();
  const [currentTab, setCurrentTab] = useState<LogTabEnum>((searchTab as LogTabEnum) ?? LogTabEnum.Application);
  const [currentConsumerId, setCurrentConsumer] = useState<string | undefined>(searchConsumer);
  const { data, isLoading } = useStoreSelector((state) => state.consumers);
  const { action: getAccess } = useLazyQuery(
    useLazyGetAccessTokenQuery(),
    consumersActions,
    consumersActions.setAccess,
  );

  const options = Object.values(data).map((current) => ({
    label: current.name,
    value: current.id,
  }));

  useEffect(() => {
    if (isString(currentConsumerId) && isExist(data[currentConsumerId])) {
      void getAccess(data[currentConsumerId]);
      setSearchParams({ consumer: currentConsumerId });
    }
  }, [currentConsumerId, data]);

  useEffect(() => void setSearchParams({ currentTab: currentTab }), [currentTab]);

  return (
    <PageWrapper>
      <PageTitle>Logs</PageTitle>
      <HeaderWrapper>
        <Tabs
          activeKey={currentTab}
          items={[
            {
              key: LogTabEnum.Application,
              label: `Application Logs`,
            },
            {
              key: LogTabEnum.Consumer,
              label: `Consumer Logs`,
            },
            {
              key: LogTabEnum.Event,
              label: `Events`,
            },
          ]}
          onChange={(tab) => setCurrentTab(tab as LogTabEnum)}
        />
        {currentTab !== LogTabEnum.Application && (
          <ConsumerSelect<string>
            options={options}
            placeholder='Select consumer'
            value={currentConsumerId}
            onChange={(consumerId) => setCurrentConsumer(consumerId as string)}
          />
        )}
      </HeaderWrapper>
      {currentTab === LogTabEnum.Application && <ApplicationLogs isLoading={isLoading} />}
      {currentTab === LogTabEnum.Consumer && (
        <RequestLogs currentConsumerId={currentConsumerId} isLoading={isLoading} />
      )}
      {currentTab === LogTabEnum.Event && <EventLogs currentConsumerId={currentConsumerId} isLoading={isLoading} />}
    </PageWrapper>
  );
};
